module.exports = __webpack_public_path__ + "img/nunu-mantul.29a8572e.png";